import { useMemo } from "react";

import { useBmaOrgsList } from "../api";
import type { BmaOrgSummary } from "../api";

// BMA returns the role in ``type``; match case-insensitively so a casing change
// on the BMA side doesn't empty the picker.
const orgNamesByType = (orgs: BmaOrgSummary[], type: string): string[] => {
  const wanted = type.toLowerCase();
  const names = new Set<string>();
  for (const o of orgs) {
    if ((o.type ?? "").toLowerCase() === wanted && o.name) names.add(o.name);
  }
  return [...names].sort((a, b) => a.localeCompare(b));
};

export const useGlobalDataScopeOptions = () => {
  const orgs = useBmaOrgsList();
  const tenantOptions = useMemo(
    () => orgNamesByType(orgs.data ?? [], "TENANT"),
    [orgs.data],
  );
  const landlordOptions = useMemo(
    () => orgNamesByType(orgs.data ?? [], "LANDLORD"),
    [orgs.data],
  );
  return { tenantOptions, landlordOptions, orgsError: orgs.isError };
};
